/* Права ролей — зеркало backend/src/utils/permissions.js.

   Здесь они нужны только чтобы не показывать кнопки, которых человек всё равно
   не сможет нажать. Настоящая защита — на сервере: даже если что-то не скрыли,
   запрос вернётся с отказом. Меняешь матрицу здесь — поменяй и на сервере. */

export const ROLE_LABELS = {
  admin: 'Главный администратор',
  manager: 'Менеджер',
  curator: 'Куратор',
  student: 'Ученик',
};

export const ROLE_HINTS = {
  admin: 'Полный доступ ко всему',
  manager: 'Ученики, зачисление и доступы',
  curator: 'Проверка ДЗ и просмотр данных',
};

export const STAFF_ROLES = ['admin', 'manager', 'curator'];

const PERMS = {
  admin: ['*'],
  manager: [
    'students.view', 'students.invite', 'students.edit', 'students.code',
    'students.enroll', 'students.unenroll', 'students.archive', 'students.delete',
    'access.extend',
    'stats.view', 'courses.view', 'staff.view',
    'ui.sessions',              // чисто интерфейсное: карточка активных сессий
  ],
  curator: [
    'students.view', 'students.code', 'students.enroll',   // на курс добавляет, снимать не может
    'stats.view', 'courses.view', 'staff.view',
    'homework.review',
  ],
};

export function canRole(role, perm) {
  const list = PERMS[role] || [];
  return list.includes('*') || list.includes(perm);
}

export const isStaff = (role) => STAFF_ROLES.includes(role);
